import { SupportedTriggerEvent, TriggerType } from 'dashboard/models/trigger';
import { EVENT_NAME_TO_DESCRIPTION } from 'lib/constants/events';
import { ApiModel } from 'lib/interfaces/api';
import { assertNever } from 'lib/utils/types';

export const getTriggerDescription = (
  triggerType: TriggerType,
  eventName: SupportedTriggerEvent | undefined,
) => {
  switch (triggerType) {
    case ApiModel.TriggerCase:
      return 'Case Action';
    case ApiModel.TriggerComputedField:
      return 'Trigger: Computed Field';
    case ApiModel.TriggerSchedule:
      return 'Schedule';
    case ApiModel.TriggerRecurring:
      return 'Recurring';
    case ApiModel.TriggerApi:
      return 'API';
    case ApiModel.TriggerEvent:
      return EVENT_NAME_TO_DESCRIPTION[eventName as SupportedTriggerEvent];
    case ApiModel.TriggerDirect:
    case ApiModel.TriggerAccount:
      // Return empty string: trigger direct and account will not be displayed on workflow index page
      return '';
    default:
      assertNever(triggerType);
  }
};
